import { strIsEmpty,
          objIsNull,
        } from '../valid/valid_util'

import {uppercaseFirst} from '../str/str_util'

const recoverVuexObj = function (state, key) {
  const json = sessionStorage.getItem(key)
  if(strIsEmpty(json)) {
    state[key] = {}
    return
  }

  const obj = JSON.parse(json)
  if(objIsNull(obj)) {
    state[key] = {}
  }

  state[key] = obj
}

const recoverVuexValue = function (state, key) {
  const value = sessionStorage.getItem(key)

  state[key] = value
}

// const recoverVuexList = function (state, key) {
//   const json = sessionStorage.getItem(key)
//   if(strIsEmpty(json)) {
//     state[key] = []
//   }

//   const list = JSON.parse(json)
//   if(listIsEmpty(list)) {
//     state[key] = []
//   }

//   state[key] = list
// }

// 从SessionStorage中恢复Vuex
const recoverVuex = function (state) {

  // 遍历state对象的所有属性名
  for(var item in state){
    //取出属性
    let property = state[item]

    switch(typeof(property)) {
      //属性是对象/数组
      case 'object':
        recoverVuexObj(state, item)
        break
      //属性是字符串、数字、布尔
      case 'string':
      case 'number':
      case 'boolean':
        recoverVuexValue(state, item)
        break
      // 属性是"function"、"undefined"
      default:
        break
    }
  }
}

// 将任意变量存入SessionStorage
const saveInSessionStorage = function(prop, key) {
  if(Array.isArray(prop) || typeof(prop)==='object'){
    const json = JSON.stringify(prop)
    sessionStorage.setItem(key, json)
    return
  }else{
    sessionStorage.setItem(key, prop)
  }
}

//数组、对象若为空，则向后台请求数据
const requestDataIfAbsent = async function(keys, store){
  // 遍历state对象的所有属性名
  keys.forEach( function(item){
    //取出属性
    let value = store.state[item]

    //属性是数组
    //数组不为空
    if(Array.isArray(value) && value.length>0){
      return
    }

    //属性是对象
    //判断是否对象内有属性
    if(typeof(property) === 'object' && Object.keys(value).length > 0){
      return
    }

    //若对象、数组不为空，则向后端请求数据
    let getfuncName = 'get'+uppercaseFirst(item)
    store.dispatch(getfuncName);
  })
}

export {
  recoverVuex,
  saveInSessionStorage,
  requestDataIfAbsent
}